"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import { getRecentlyViewedIds } from "@/hooks/use-recently-viewed";
import type { TransformedProduct } from "@/lib/shared/utils";
import ProductCard from "@/components/product/ProductCard";
import Reveal from "@/components/motion/Reveal";

export default function RecentlyViewedRail({ currentId }: { currentId?: number }) {
  const [products, setProducts] = useState<TransformedProduct[]>([]);
  useEffect(() => {
    const ids = getRecentlyViewedIds().filter((id) => id !== currentId).slice(0, 4);
    if (ids.length === 0) return;
    fetch("/api/products/batch", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ids }) })
      .then((r) => r.json())
      .then((d) => setProducts(d.products || []))
      .catch(() => {});
  }, [currentId]);
  if (products.length === 0) return null;
  return (
    <section className="border-foreground/10 bg-background border-t px-4 py-10 lg:px-12 lg:py-12">
      <Reveal width="100%" delay={0.2}>
        <div className="mb-6 flex items-center justify-between">
          <h2 className="text-xl font-black tracking-tighter uppercase lg:text-2xl">Recently viewed</h2>
          <Link href="/products" className="border-foreground border-b pb-0.5 text-xs font-bold tracking-[0.2em] uppercase transition-opacity hover:opacity-50">
            View All
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 lg:gap-6">
          {products.map((p, idx) => (
            <ProductCard key={p.id} {...p} stock={p.stock} index={idx} />
          ))}
        </div>
      </Reveal>
    </section>
  );
}
